import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'boolean',
})
export class BooleanPipe implements PipeTransform {
  transform(value: unknown): unknown {
    return value ? $localize`Yes` : $localize`No`;
  }
}
